import * as Sentry from "@sentry/react";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useRouter } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";
import { ApiError } from "@/client/lib/api";

/**
 * Tela de erro amigável das rotas (o menu continua visível; só o conteúdo
 * troca). Erro de API conhecido mostra a mensagem do servidor.
 */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  const { reset: resetQueries } = useQueryErrorResetBoundary();

  useEffect(() => {
    if (!(error instanceof ApiError) || error.status >= 500) Sentry.captureException(error);
  }, [error]);

  const known = error instanceof ApiError && error.status < 500;
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <div className="flex flex-col items-center gap-4 rounded-xl border border-slate-200 bg-white px-6 py-16 text-center shadow-card">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50">
          <AlertTriangle className="h-7 w-7 text-amber-600" />
        </div>
        <div>
          <h2 className="font-display text-xl font-bold text-slate-800">Algo deu errado</h2>
          <p className="mt-1.5 text-sm text-slate-500">
            {known ? error.message : "Não foi possível carregar esta tela. Pode ser uma instabilidade momentânea."}
          </p>
        </div>
        <button
          type="button"
          onClick={() => {
            resetQueries();
            reset();
            void router.invalidate();
          }}
          className="rounded-lg bg-brand-700 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-800"
        >
          Tentar novamente
        </button>
      </div>
    </div>
  );
}
